import { post, get } from './request'

export const AUTH_API_VISITOR_INIT = '/visitor/api/init/'
export const AUTH_API_REGISTER_USER = '/visitor/api/register_user/'
export const AUTH_API_LOGOUT = '/visitor/api/reset/'
export const DIRECTORY_BUSINESS_API = '/directory/api/business/'
export const DIRECTORY_APP_API = '/directory/api/application/'

export const API_NOTIFICATION = '/visitor/service/notification/'

export const initGoid = (data) => post(`${AUTH_API_VISITOR_INIT}`, data)
export const registerUser = (data) => post(`${AUTH_API_REGISTER_USER}`, data)
export const logout = (_goid) => post(`${AUTH_API_LOGOUT}`, { _goid })
export const getBusinessInfo = () => get(`${DIRECTORY_BUSINESS_API}/0`)
export const getAppSettings = () => get(`${DIRECTORY_APP_API}/0`)
export const notificationList = () => get(`${API_NOTIFICATION}`)
export const markAllAsReadNotification = () => post(`${API_NOTIFICATION}mark_read_all/`)
